import { NVBasicBaseApi } from "../NVBasicBaseApi";

export class ActreflowConditionApi extends NVBasicBaseApi {

    public get ControllerName(): any {
        return 'actflowCondition';
    }

}
